import { useMemo } from 'react'
import { useLayoutStore } from '@/workspace/layout-store/hooks'
import { drillSourcePanelIds, type LeafProvenance } from '../utils/leaf-provenance'

/**
 * Panel ids that own at least one active drill leaf (a bar, cell, or flow the
 * user double-clicked into the page filters). The workspace frames highlight
 * these so the drill's origin stays visible while its chip is active.
 *
 * Reads `globalSettings.historyFilters.leafProvenance` straight from the
 * layout store. The selector returns a joined string, exactly like the
 * mosaic's focus-date and deviated-id keys, so the frame only re-renders when
 * the set of source panels actually changes. Off the History page the map is
 * absent and the key is empty, so dashboard panels pay nothing.
 */
export function useDrillSourcePanelIds(): ReadonlySet<string> {
  const key = useLayoutStore((s) => {
    const hf = s.globalSettings?.historyFilters
    if (!hf || typeof hf !== 'object' || Array.isArray(hf)) return ''
    const provenance = (hf as { leafProvenance?: LeafProvenance }).leafProvenance
    if (!provenance) return ''
    return drillSourcePanelIds(provenance).join(',')
  })
  return useMemo(() => new Set(key ? key.split(',') : []), [key])
}
